import { Component, Input, OnInit, inject } from '@angular/core';
import { AppService } from '../../../_services/app.service';

@Component({
  selector: 'manager-loader-wrapper-page',
  templateUrl: './loader_wrapper_page.component.html',
  standalone: false,
})
export class LoaderWrapperPageComponent {
  appS = inject(AppService);

  @Input() type: string;
  @Input() wrapper: string;
}
